import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '@/api/client'

export const useSiteConfigStore = defineStore('siteConfig', () => {
  const registrationEnabled = ref(true)
  const waitlistEnabled = ref(false)
  const googleEnabled = ref(false)
  const googleClientId = ref<string | null>(null)
  const loaded = ref(false)

  async function load() {
    if (loaded.value) return
    try {
      const { data } = await api.get<{
        registration_enabled: boolean
        waitlist_enabled?: boolean
        google_enabled?: boolean
        google_client_id?: string | null
      }>('/public/portal-config')
      registrationEnabled.value = data.registration_enabled
      waitlistEnabled.value = data.waitlist_enabled ?? !data.registration_enabled
      googleClientId.value = data.google_client_id?.trim() || null
      googleEnabled.value = Boolean(data.google_enabled && googleClientId.value)
    } catch {
      /* keep default true — fail open */
    }
    loaded.value = true
  }

  return { registrationEnabled, waitlistEnabled, googleEnabled, googleClientId, loaded, load }
})
